export default __webpack_public_path__ + "static/media/circleOutline.6e6deba0.svg";